import { render, staticRenderFns } from "./AddResponsibilityDialog.vue?vue&type=template&id=fc8f3772&scoped=true"
import script from "./AddResponsibilityDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddResponsibilityDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddResponsibilityDialog.vue?vue&type=style&index=0&id=fc8f3772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8f3772",
  null
  
)

export default component.exports